import { getCurrentScope, setUser } from '@sentry/browser';
import redux from 'redux';
import { AUTHENTICATION_FAILED, AUTHENTICATION_LOGGED_IN, AUTHENTICATION_LOGGING_IN, AUTHENTICATION_LOGOUT } from './actions';

export interface IAuthenticationState {
    userId?: string;
    loggedIn: boolean;
    emailAddress?: string;
    firstName?: string;
    lastName?: string;
    token?: string;
    role?: string;
    loggingIn: boolean;
    failed: boolean;
    companyId?: string;
    isReadOnly?: boolean;
    isAccountManager?: boolean;
    isConfigurationManager?: boolean;
    isDroneOperator?: boolean;
    isClient?: boolean;
    isTempLogin?: boolean;
    clientName?: string;
    customerVersion?: string;
    useNen2767Advanced?: boolean;
    useBatches?: boolean;
    useSurveyComments?: boolean;
    loginAttempts?: number;
    code?: string;
    isSsoLogin?: boolean;
    hasOtpEnabled?: boolean;
    needsOtp: boolean;
    isPdokMapLayerAvailable?: boolean;
    areLabelsVisibleInOverviews?: boolean;
    isDroneNoFlyMapNlAvailable?: boolean;
    shouldClusterMarkers?: boolean;
    useObjectRelations?: boolean;
    restrictedHostName?: string;
    shouldEnforceMfa?: boolean;
    useEquipmentManagement?: boolean;
    useProductTitle?: boolean;
}

function authentication(
    state: IAuthenticationState = { loggedIn: false, loggingIn: false, failed: false, needsOtp: false },
    action: any = {},
): IAuthenticationState {
    switch (action.type) {
        case AUTHENTICATION_LOGGED_IN:
            sessionStorage.setItem('zxy-token', action.user.token);
            sessionStorage.setItem('zxyEmailAddress', action.user.emailAddress);
            sessionStorage.setItem('zxyUserId', action.user.id);
            sessionStorage.setItem('zxyRole', action.user.role);
            (window as any).zxyEmailAddress = action.user.emailAddress;

            getCurrentScope().setUser({
                email: action.user.emailAddress,
                id: action.user.id,
                role: action.user.role,
            });

            return {
                userId: action.user.id,
                loggedIn: true,
                loggingIn: false,
                failed: false,
                emailAddress: action.user.emailAddress,
                firstName: action.user.firstName,
                lastName: action.user.lastName,
                token: action.user.token,
                role: action.user.role,
                companyId: action.user.companyId,
                isReadOnly: action.user.isReadOnly,
                isAccountManager: action.user.isAccountManager,
                isConfigurationManager: action.user.isConfigurationManager,
                isClient: action.user.isClient,
                isDroneOperator: action.user.isDroneOperator,
                isTempLogin: action.user.isTempLogin,
                customerVersion: action.user.customerVersion,
                useNen2767Advanced: action.user.useNen2767Advanced,
                useObjectRelations: action.user.useObjectRelations,
                useBatches: action.user.useBatches,
                useSurveyComments: action.user.useSurveyComments,
                clientName: action.user.clientName,
                isSsoLogin: action.user.isSsoLogin,
                hasOtpEnabled: action.user.hasOtpEnabled,
                needsOtp: false,
                isPdokMapLayerAvailable: action.user.isPdokMapLayerAvailable,
                areLabelsVisibleInOverviews: action.user.areLabelsVisibleInOverviews,
                isDroneNoFlyMapNlAvailable: action.user.isDroneNoFlyMapNlAvailable,
                shouldClusterMarkers: action.user.shouldClusterMarkers,
                shouldEnforceMfa: action.user.shouldEnforceMfa,
                useEquipmentManagement: action.user.useEquipmentManagement,
                useProductTitle: action.user.useProductTitle,
            };
        case AUTHENTICATION_LOGGING_IN:
            return {
                loggedIn: false,
                loggingIn: true,
                failed: false,
                needsOtp: false,
            };
        case AUTHENTICATION_LOGOUT:
            (window as any).zxyEmailAddress = undefined;
            sessionStorage.removeItem('zxyEmailAddress');
            setUser(null);
            return {
                loggedIn: false,
                loggingIn: false,
                failed: false,
                needsOtp: false,
            };
        case AUTHENTICATION_FAILED:
            return {
                failed: true,
                loggedIn: false,
                loggingIn: false,
                code: action.code,
                needsOtp: state.needsOtp,
                restrictedHostName: action.restrictedHostName,
            };
        default:
            return state;
    }
}
export const rootReducer: redux.Reducer<IAuthenticationState> = authentication;
